/**
 * @generated SignedSource<<49acbc74c513d49bf6e074217fd397e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WATeamScheduleSettings_teamDialog$data = ReadonlyArray<{
  readonly id: string;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  readonly " $fragmentType": "WATeamScheduleSettings_teamDialog";
}>;
export type WATeamScheduleSettings_teamDialog$key = ReadonlyArray<{
  readonly " $data"?: WATeamScheduleSettings_teamDialog$data;
  readonly " $fragmentSpreads": FragmentRefs<"WATeamScheduleSettings_teamDialog">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WATeamScheduleSettings_teamDialog",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamIconCircleComponent_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "984e0c6fc4447353287c171511e5f09a";

export default node;
